<template>
  <v-container style="padding: 0">
    <v-expansion-panels v-model="dropdownOpen">
      <v-expansion-panel :disabled="disabled">
        <v-expansion-panel-header>
          <div>
            <div :style="`background-color: ${defaultColor}`" class="color-dot" style="margin: 0"></div>
          </div>
          <span>{{title}}</span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-list>
            <v-list-item
              v-for="(x, i) in colors"
              :key="`col-${i}`"
              class="color-row"
              @click="makeDefault(i)"
            >
              <div :style="`background-color: ${x.code}`" :class="(x.code === defaultColor) ? 'color-dot-bold' : 'color-dot'"></div>
              <span :style="(x.code === defaultColor) ? 'font-weight: bold' : ''">{{x.label}}</span>
              <v-btn @click.stop="onClickRow(i)" icon style="position: absolute; right: 10px;" >
                <v-icon color="darken-2">
                  mdi-dots-horizontal
                </v-icon>
              </v-btn>
            </v-list-item>
          </v-list>
          <v-row justify="center">
            <v-btn
              color="rgb(255, 149, 24)"
              large
              rounded
              width="80%"
              @click="addDialog = true"
            >
              <div>
                {{buttonText}}
              </div>
            </v-btn>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <AddColorModal
      :title="buttonText"
      :dialog="addDialog"
      @addColor="onAddColor"
      @close="addDialog = false"
    />
    <EditColorModal
      :dialog="editDialog"
      :code="editCode"
      :label="editLabel"
      :canDelete="this.colors.length > 1"
      @delete="onDelete"
      @update="onUpdate"
      @close="editDialog = false"
    />
  </v-container>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import AddColorModal from './AddColorModal'
import EditColorModal from './EditColorModal'

export default {
  name: 'ColorList',
  props: ['title', 'buttonText', 'colorsField', 'defaultColorField', 'disabled'],
  components: {
    AddColorModal,
    EditColorModal
  },

  data () {
    return {
      addDialog: false,
      editDialog: false,
      editCode: '#FF0000',
      editLabel: '',

      editIndex: 0,

      dropdownOpen: false
    }
  },

  computed: {
    ...mapState({
      currentlyViewedChallenge: state => state.challenge.currentlyViewedChallenge
    }),
    colors () {
      return this.currentlyViewedChallenge[this.colorsField]
    },
    defaultColor () {
      return this.currentlyViewedChallenge[this.defaultColorField]
    }
  },

  methods: {
    ...mapMutations(['setCurrentlyViewedChallenge']),

    onClickRow (i) {
      console.log('clicked', this.colors[i])
      this.editIndex = i
      this.editCode = this.colors[i].code
      this.editLabel = this.colors[i].label
      this.editDialog = true
    },

    onDelete () {
      const updatedChallenge = this.currentlyViewedChallenge
      updatedChallenge[this.colorsField].splice(this.editIndex, 1)
      this.setCurrentlyViewedChallenge(updatedChallenge)
    },
    makeDefault (i) {
      const updatedChallenge = this.currentlyViewedChallenge
      updatedChallenge[this.defaultColorField] = this.colors[i].code
      this.setCurrentlyViewedChallenge(updatedChallenge)
      this.dropdownOpen = false
    },
    onUpdate (newColor) {
      const updatedChallenge = this.currentlyViewedChallenge

      if (updatedChallenge[this.colorsField][this.editIndex].code === this.defaultColor) {
        updatedChallenge[this.defaultColorField] = newColor.code
      }

      updatedChallenge[this.colorsField][this.editIndex].code = newColor.code
      updatedChallenge[this.colorsField][this.editIndex].label = newColor.label
      this.setCurrentlyViewedChallenge(updatedChallenge)
    },
    onAddColor (newColor) {
      const updatedChallenge = this.currentlyViewedChallenge
      updatedChallenge[this.colorsField].push(newColor)
      this.setCurrentlyViewedChallenge(updatedChallenge)
    }
  }
}
</script>

<style lang="sass" scoped>
  .color-row:hover
    background-color: rgba(0, 0, 0, 0.1)
    cursor: pointer

  .color-dot
    margin-right: 10px
    width: 20px
    height: 20px
    border-radius: 10px
    border: black solid 1px

  .color-dot-bold
    margin-right: 10px
    width: 20px
    height: 20px
    border-radius: 10px
    border: black solid 2px
</style>
